import React from 'react';

interface KitingSettings {
  enabled: boolean;
  rightClickKey: string;
  hideRCButtons: boolean;
  hideLCButtons: boolean;
  attackMoveClick: boolean;
}

interface KitingSettingsProps {
  kitingSettings: KitingSettings;
  onKitingSettingsChange: (settings: KitingSettings) => void;
  show: boolean;
}

const KitingSettingsComponent: React.FC<KitingSettingsProps> = ({
  kitingSettings,
  onKitingSettingsChange,
  show
}) => {
  const updateSettings = (updates: Partial<KitingSettings>) => {
    onKitingSettingsChange({ ...kitingSettings, ...updates });
  };

  if (!show) return null;

  return (
    <div className="kiting-settings">
      <div className="kiting-layout">
        <div className="kiting-main-section">
          <div className="kiting-main-toggle">
            <label className="kiting-main-label">
              <input
                type="checkbox"
                checked={kitingSettings.enabled}
                onChange={(e) => updateSettings({ enabled: e.target.checked })}
                className="kiting-checkbox"
              />
              <div className="kiting-text-group">
                <span className="kiting-title">Kiting</span>
                <span className="kiting-subtitle">Enable kiting mode</span>
              </div>
            </label>
          </div>
          <div className="kiting-description">
            When enabled, right-click anywhere on the practice field below to register kiting movements. 
            Right-clicks are always optional and won't affect your combo accuracy.
          </div>
        </div>
        
        <div className={`kiting-settings-panel ${!kitingSettings.enabled ? 'disabled' : ''}`}>
          <div className="kiting-setting">
            <label className="kiting-toggle-label">
              <input
                type="checkbox"
                checked={kitingSettings.hideRCButtons}
                onChange={(e) => updateSettings({ hideRCButtons: e.target.checked })}
                className="kiting-checkbox"
                disabled={!kitingSettings.enabled}
              />
              <span className="kiting-toggle-text">Hide RC buttons</span>
            </label>
            <div className="kiting-setting-description">
              Hides right-click buttons from the visual sequence to reduce clutter.
            </div>
          </div>
          
          <div className="kiting-setting">
            <label className="kiting-toggle-label">
              <input
                type="checkbox"
                checked={kitingSettings.hideLCButtons}
                onChange={(e) => updateSettings({ hideLCButtons: e.target.checked })}
                className="kiting-checkbox"
                disabled={!kitingSettings.enabled}
              />
              <span className="kiting-toggle-text">Hide LC buttons</span>
            </label>
            <div className="kiting-setting-description">
              Hides left-click buttons from the visual sequence to reduce clutter.
            </div>
          </div>
          
          <div className="kiting-setting">
            <label className="kiting-toggle-label">
              <input
                type="checkbox"
                checked={kitingSettings.attackMoveClick}
                onChange={(e) => updateSettings({ attackMoveClick: e.target.checked })}
                className="kiting-checkbox"
                disabled={!kitingSettings.enabled}
              />
              <span className="kiting-toggle-text">Attack-move click</span>
            </label>
            <div className="kiting-setting-description">
              Requires left-click confirmation after pressing A. Other inputs cancel pending auto attacks.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KitingSettingsComponent;